export const GURUS_GET = 'GURUS_GET';
export const GURU_JENJANGS_GET = 'GURU_JENJANGS_GET';
export const GURU_ADD = 'GURU_ADD';
export const GURU_EDIT = 'GURU_EDIT';
export const GURU_GET = 'GURU_GET';
export const GURU_DELETE = 'GURU_DELETE';
